import {Component, Input, OnInit} from '@angular/core';
import {NbDialogRef} from '@nebular/theme';
import {BaseDialog} from '../base-dialog';
import {Router} from '@angular/router';
import {WelfyProjectSetup} from '../../../class/welfy-project-setup';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-simulation-type-dialog',
  templateUrl: './simulation-type-dialog.component.html',
  styleUrls: ['./simulation-type-dialog.component.css']
})
export class SimulationTypeDialogComponent extends BaseDialog<WelfyProjectSetup> implements OnInit {

  projectSettings: WelfyProjectSetup;
  form: FormGroup;
  invalid: boolean;

  @Input()
  showImportCustomer = true;

  @Input()
  importExistingCustomer = false;

  constructor(dialogRef: NbDialogRef<WelfyProjectSetup>, route: Router) {
    super(dialogRef, route);
  }

  ngOnInit() {
    this.form = new FormGroup(
      {
        'project-name': new FormControl('', [Validators.required])
      }
    );
    this.projectSettings = new WelfyProjectSetup();
    this.projectSettings.importCustomer = this.importExistingCustomer;
  }

  close(result?, closeRedirect?) {
    if (this.form.valid) {
      this.projectSettings.name = this.form.get('project-name').value;
      super.close(result);
    } else {
      this.invalid = true;
    }
  }

  closeDialog(){
    this.redirect = "/";
    super.close();
  }
}
